import { RoutingService } from './../../../../services/routing/routing.service';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  EContentService,
  ResponseMessages,
} from '../../../../services/thirdparty/econtent.service';
import { SharedService } from '../../../../services/shared/shared.service';
import {
  MagazineProduct,
  OverDriveItem,
} from '../../../../services/thirdparty/overdrive/overdrive.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { OverdriveMagazineDialogComponent } from './overdrive-magazine-dialog/overdrive-magazine-dialog.component';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'ag-overdrive-fullrecord',
  templateUrl: './overdrive-fullrecord.component.html',
  styleUrls: ['./overdrive-fullrecord.component.scss'],
})
export class OverDriveFullRecordComponent implements OnInit, OnChanges {
  @Input() item: OverDriveItem;
  @Input() format: string;
  @Input() isGuest: boolean;
  @Output() refreshItem = new EventEmitter<null>();
  @Output() placeHold = new EventEmitter<null>();
  @Output() selectedProduct = new EventEmitter<MagazineProduct>();

  magazineEdition: string;

  constructor(
    private _eContentService: EContentService,
    private _sharedService: SharedService,
    private _routingService: RoutingService,
    private _dialog: MatDialog,
    private _overlay: Overlay,
  ) {}

  ngOnInit(): void {
    this.magazineEdition = this.item?.magazineIssues?.products[0].edition;
  }

  ngOnChanges({ item }: SimpleChanges): void {
    this.item = item?.currentValue;
    this.magazineEdition =
      this.magazineEdition ?? item?.currentValue?.magazineIssues?.products[0].edition;
  }

  showSample(Url): void {
    window.open(Url);
  }

  placeItemHold(): void {
    this.placeHold.emit();
  }

  cancelOverDriveHold(): void {
    this._eContentService.overDriveCancelHold(this.item.productId).subscribe(
      () => {
        this._sharedService.openSnackBar(ResponseMessages.CANCEL_SUCCESS, 'ok');
        this.refresh();
      },
      () => {
        this._sharedService.openSnackBar(ResponseMessages.CANCEL_ERROR, 'ok');
      },
    );
  }

  earlyReturn(): void {
    this._eContentService.overDriveEarlyReturn(this.item.productId).subscribe(
      () => {
        this._sharedService.openSnackBar(ResponseMessages.EARLY_RETURN_SUCCESS, 'ok');
        this.refresh();
      },
      () => {
        this._sharedService.openSnackBar(ResponseMessages.EARLY_RETURN_ERROR, 'ok');
      },
    );
  }

  goToOverDriveFulfillment(): void {
    this._eContentService.overDriveGetDownloadLink(this.item.downloadRedirectLink).subscribe(
      (response) => {
        window.open(response, '_blank');
      },
      () => {
        this._sharedService.openSnackBar(ResponseMessages.GENERIC_ERROR, 'ok');
      },
    );
  }

  checkout(): void {
    this._eContentService.overDriveCheckOut(this.item.productId).subscribe(
      (response) => {
        window.open(response, '_blank');
        this.refresh();
      },
      () => {
        this._sharedService.openSnackBar(ResponseMessages.GENERIC_ERROR, 'ok');
      },
    );
  }

  toggleMagazineEdition(magazineIssue: MagazineProduct): void {
    this.item.productId = magazineIssue.id;
    this.item.isCheckedOut = magazineIssue.isCheckedOut;
    this.item.downloadRedirectLink = magazineIssue.downloadRedirectLink;
    this.magazineEdition = magazineIssue.edition;
    this.selectedProduct.emit(magazineIssue);
  }

  refresh(): void {
    this.refreshItem.emit();
  }

  login(): void {
    this._routingService.goToLogin();
  }

  openDialog() {
    const dialog = this._dialog.open(OverdriveMagazineDialogComponent, {
      scrollStrategy: this._overlay.scrollStrategies.noop(),
      width: '300px',
      data: {
        title: 'Magazine Editions',
        magazineIssues: this.item.magazineIssues.products,
        selectedMagazineEdition: this.magazineEdition,
      },
    });

    dialog.afterClosed().subscribe((magazine: MagazineProduct) => {
      if (magazine) {
        this.toggleMagazineEdition(magazine);
      }
    });
  }
}
